import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  InputNumber,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
import moment from "moment";
const { Option } = Select;
const { RangePicker } = DatePicker;

const BalanceTransactionTableFilter = (props) => {
  const [form] = Form.useForm();

  const [transactionTypes, setTransactionTypes] = useState({
    data: [],
  });
  const [balanceProcessTypes, setBalanceProcessTypes] = useState({
    data: [],
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    RequestHandler.get(`/Types/GetManualTransactionTypes`).then((response) => {
      setTransactionTypes({
        data: response,
      });
    });
  }, []);

  useEffect(() => {
    RequestHandler.get(`/Types/GetBalanceProcessTypes`).then((response) => {
      setBalanceProcessTypes({
        data: response,
      });
    });
  }, []);

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.transactionDateRange) {
        const [startDate, endDate] = values.transactionDateRange;
        conditions.push(odata.dateRange("addDate", startDate, endDate));
      }
      if (values.balanceProcessType) {
        conditions.push(
          `balanceProcessTypeValue eq ${values.balanceProcessType}`
        );
      }

      if (values.amountMin) {
        conditions.push(`amount Ge ${values.amountMin}`);
      }

      if (values.amountMax) {
        conditions.push(`amount Le ${values.amountMax}`);
      }

      if (values.transactionProcessType) {
        conditions.push(
          `transactionProcessTypeValue eq ${values.transactionProcessType}`
        );
      }
      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }
      if (props.onFinishFilter) props.onFinishFilter(query);

      if (query) {
        query = "$filter=" + query;
      }
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <>
      <Row id="filterArea" style={{ ...props.style }}>
        <Col span={24}>
          <Collapse>
            <Collapse.Panel header="Filtreleme için tıklayınız.">
              <Form
                name="filter"
                form={form}
                initialValues={{
                  remember: true,
                }}
                layout="vertical"
                onFinish={onFinish}
              >
                <Row style={{ flexDirection: "row" }}>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="balanceProcessType" label="İşlem :">
                      <Select
                        name="balanceProcessTypes"
                        style={{ width: "100%" }}
                        loading={false}
                        placeholder="İşlem"
                      >
                        {balanceProcessTypes.data.map((item) => (
                          <Option key={item.key} value={item.key}>
                            {item.value}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="transactionDateRange" label="Tarih :">
                      <RangePicker
                        format="DD.MM.YYYY"
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={6}>
                    <Form.Item
                      name="transactionProcessType"
                      label="İşlem Tipi :"
                    >
                      <Select
                        name="transactionProcessTypes"
                        style={{ width: "100%" }}
                        loading={false}
                        placeholder="İşlem Tipi"
                      >
                        {transactionTypes.data.map((item) => (
                          <Option key={item.key} value={item.key}>
                            {item.value}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item label="Tutar Aralığı :">
                      <Input.Group>
                        <Row gutter={1} style={{ flexDirection: "row" }}>
                          <Col span={12}>
                            <Form.Item name="amountMin">
                              <InputNumber
                                min={0}
                                style={{ width: "100%" }}
                                placeholder="Başlangıç"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item name="amountMax">
                              <InputNumber
                                min={0}
                                style={{ width: "100%" }}
                                placeholder="Bitiş"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ flexDirection: "row" }}>
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Button
                      danger
                      size="small"
                      icon={<CloseOutlined />}
                      onClick={() => clearFilter()}
                    >
                      Sıfırla
                    </Button>
                    <Button
                      type="primary"
                      size="small"
                      icon={<SearchOutlined />}
                      style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                      htmlType="submit"
                    >
                      Filtrele
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>
    </>
  );
};
export default BalanceTransactionTableFilter;
